"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Style = exports.CSS = void 0;
const theme_1 = require("../theme");
exports.CSS = {
    container: 'c-Table',
    title: 'c-Table__Title',
    header: 'c-Table__Header',
    body: 'c-Table__Body',
    row: 'c-Table__row',
    cell: 'c-Table__cell',
    MDL: {
        table: 'mdl-data-table',
        cell: 'mdl-data-table__cell--non-numeric'
    }
};
const TITLE_HEIGHT = theme_1.DefaultTheme.space(12);
exports.Style = {
    [exports.CSS.container]: {
        'box-shadow': theme_1.DefaultTheme.shadow.box.dp2,
        margin: theme_1.DefaultTheme.space(4)
    },
    [exports.CSS.title]: {
        display: 'flex',
        'justify-content': 'space-between',
        height: TITLE_HEIGHT,
        'line-height': TITLE_HEIGHT,
        padding: `0 ${theme_1.DefaultTheme.space(6)}`,
        '& h6': {
            margin: 0,
            'line-height': TITLE_HEIGHT
        }
    },
    [`${exports.CSS.header} th`]: {
        'font-weight': theme_1.DefaultTheme.font.weight.normal
    },
    [exports.CSS.body]: {
        width: '100%',
        border: 0,
        'background-color': 'transparent',
        'table-layout': 'fixed',
        '& td:first-of-type, & th:first-of-type': {
            width: '100px'
        }
    },
    [exports.CSS.cell]: {
        'max-width': '100%',
        'text-overflow': 'ellipsis',
        'white-space': 'nowrap',
        overflow: 'hidden'
    }
};
//# sourceMappingURL=table.style.js.map